import { Accordion, Flex, Loader, Text, useMantineTheme } from "@mantine/core";
import { Pagination } from "../../../../components";
import { DocumentText } from "iconsax-react";
import { useState } from "react";
import TableHistory from "./TableHistory";

import { useMyHistoryPlans } from "../../../../hooks/useMyPlans";
import { IQuery } from "../../../../interfaces/IQuery";
import { IMyProducts } from "../../../../interfaces/MyProducts";
import { useTranslation } from "react-i18next";

interface IProps {
  product: IMyProducts;
}

const AccordionHistory = ({ product }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const [query, setQuery] = useState<IQuery>({
    page: 1,
    pageSize: 10,
    id: "",
  });
  const { data: history, isLoading: isLoadingHistory } =
    useMyHistoryPlans(query);

  const pagination = {
    page: query.page,
    pageSize: query.pageSize,
    totalElements: history?.totalElements,
    totalPages: history?.totalPages,
    view: history?.data?.length || 0,
  };

  const handleOpenHistory = () => {
    setQuery((prev) => ({ ...prev, id: product.id }));
  };

  return (
    <Accordion.Item value="History" onClick={handleOpenHistory}>
      <Accordion.Control p="0">
        <Flex
          id="lineOneCardProduct"
          justify="start"
          align={"center"}
          gap="8px"
        >
          <DocumentText size="24" color={theme.colors.basic[5]} />
          <Text
            fz={{ base: 18 }}
            lh={{ base: "155%" }}
            c={theme.colors.basic[5]}
          >
            {t("meu_portfolio.meus_serviços.card_product.history_title")}
          </Text>
        </Flex>
      </Accordion.Control>
      <Accordion.Panel
        styles={{
          ".content": {
            padding: "0px",
          },
        }}
      >
        {isLoadingHistory ? (
          <Loader color="cyan" />
        ) : !!history && history.data.length > 0 ? (
          <Flex
            gap={{ base: 16 }}
            w="fit"
            direction={"column"}
            justify={"space-between"}
            p="16px 0"
          >
            <TableHistory history={history} idProduct={product.id} />
            <Pagination
              pagination={pagination}
              onChange={(page) => setQuery({ ...query, page: page })}
            />
          </Flex>
        ) : (
          <Flex
            gap={{ base: 16 }}
            w="fit"
            direction={"column"}
            justify={"space-between"}
            p="16px 0"
          >
            <Text>{t("global.pagination.no_registered")}</Text>
          </Flex>
        )}
      </Accordion.Panel>
    </Accordion.Item>
  );
};
export default AccordionHistory;
